export default __webpack_public_path__ + "static/media/update.26205e13.png";